import React from "react";
import Header from "./components/Header";
import AllRoutes from "./AllRoutes";
import Footer from "./components/Footer";
import { CartProvider } from "./context/CartContect";
import { OrderProvider } from "./context/OrderContext";
import ChatPopup from "./pages/Chat";
import TawkChat from "./components/TalkChat";


function App() {
  return (
    <div className="App">
      <CartProvider>
        <OrderProvider>
          <Header />
          <AllRoutes />
          <Footer />
        </OrderProvider>
      </CartProvider>
      {/* <ChatPopup /> */}
      <TawkChat/>
    </div>
  );
}

export default App;
